import React from 'react'
import styled from 'styled-components'

const Column = ({
  dataId = null,
  zindex = '0',
  mwidth = '100%',
  minh = 'auto',
  width = '100%',
  br = '0',
  grow = '0',
  justify = 'space-between',
  mpad = '0',
  pad = '0',
  gap = '20px',
  mgap = gap,
  bg = 'transparent',
  motion = null,
  children,
  minmh = 'auto',
  scroll = 'visible',
}) => {
  return (
    <Wrap
      id={dataId}
      $zindex={zindex}
      $mwidth={mwidth}
      $width={width}
      $minh={minh}
      $minmh={minmh}
      $justify={justify}
      $grow={grow}
      $br={br}
      $bg={bg}
      $pad={pad}
      $mpad={mpad}
      $gap={gap}
      $mgap={mgap}
      $scroll={scroll}
      {...motion}
    >
      {children}
    </Wrap>
  )
}

export default Column

const Wrap = styled.div`
  width: ${(props) => props.$mwidth};
  min-height: ${(props) => props.$minh};
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: ${(props) => props.$mgap};
  padding: ${(props) => props.$mpad};
  justify-content: ${(props) => props.$justify};
  background: ${(props) => props.$bg};
  border-radius: ${(props) => props.$br};
  flex: ${(props) => props.$grow};
  z-index: ${(props) => props.$zindex};
  overflow-x: ${(props) => props.$scroll};

  @media (width > 800px) {
    min-height: ${(props) => props.$minh};
    width: ${(props) => props.$width};
    padding: ${(props) => props.$pad};
    row-gap: ${(props) => props.$gap};
  }
`
